import React from 'react';
import LocationTemplate from './LocationTemplate';

const ChapelHillPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Chapel Hill"
      stateName="North Carolina"
      countyName="Orange"
      zipCodes={["27514", "27515", "27516", "27517", "27599"]}
      latitude={35.9132}
      longitude={-79.0558}
      population={61960}
      historicalFact="Home to the University of North Carolina (1789), the nation's first public university."
      nearbyTowns={[
        "Durham, NC",
        "Cary, NC",
        "Pittsboro, NC",
        "Apex, NC",
        "Morrisville, NC",
        "Wake Forest, NC",
        "Holly Springs, NC",
        "Fuquay-Varina, NC"
      ]}
    />
  );
};

export default ChapelHillPage;